import React, { memo } from 'react';
import { Row, Col } from '@duxton-web/ui';
import { MoreInfoFilled } from '@duxton-web/icons';
import { Handle, Position } from 'reactflow';
import dayjs from 'dayjs';
import journeyStartIcon from 'img/journey_start.svg';
import infoIcon from 'img/info.svg';
import { NODETYPE_REQUIRED_FIELDS, NODE_TYPES } from 'components/journey-builder/utils/constants';
import { getErrors } from 'components/journey-builder/utils/core';
import 'components/journey-builder/css/journeyStart.scss';

export default memo(({ data, isConnectable }) => {
  const { isView, showMetrics } = data;
  const hasError = getErrors(data, NODETYPE_REQUIRED_FIELDS[NODE_TYPES.journeyStart]);
  const displayComponent = data.userSource.sourceID ?
    (<div>
      <Row style={{ marginTop: 12 }}>
        <Col>
          <div className="categoryHeader">
            User Segment
          </div>
          {data.userSource.sourceID}
        </Col>
      </Row>
      <Row style={{ marginTop: 12 }}>
        <Col>
          <div className="categoryHeader">
            Time
          </div>
          {dayjs(data.schedule.startTime).format('DD/MM/YYYY hh:mm A')}
        </Col>
      </Row></div>) :
    (<Row>
      <Col>
        <span>Click to edit the journey entry trigger</span>
      </Col>
    </Row>);

  return (
    <div>
      {hasError && !isView && <MoreInfoFilled className="hasError" />}
      <Row>
        <Col>
          <img src={journeyStartIcon} height={'28px'} width={'28px'} alt={''} />
        </Col>
        <Col>
          <div className="title">
            <b>Start Journey</b>
          </div>
        </Col>
      </Row>
      {displayComponent}
      {showMetrics && data.processed_count > 0 && <div>
        <div className="divider" />
        <Row>
          <Col>
            <div className="progressTextHeader">
              Processed <img src={infoIcon} height={'12px'} width={'12px'} alt={''} />
            </div>
            <div className="progressTextContent">
              {((data.success_count / (data.totalCount || 0)) * 100).toFixed(1)} %
            </div>
          </Col>
        </Row>
      </div>}
      <Handle
        type="source"
        position={Position.Bottom}
        isConnectable={isConnectable}
      />
    </div>
  );
});
